export default __webpack_public_path__ + "images/PC.db153b7.png";